import { useState } from 'react';
import { motion } from 'framer-motion';
import { FiMail } from 'react-icons/fi';
import { Button, Input, message } from 'antd';
import { Link } from 'react-router-dom';
import { apiUrl } from '../api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [messageText, setMessageText] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessageText('');
    setError('');

    try {
      const response = await fetch(apiUrl('/api/auth/forgot-password'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessageText(data.message || 'Verification mail has been sent.');
        message.success(data.message || 'Verification mail has been sent.');
      } else {
        setError(data.message || 'Unable to send verification mail');
        message.error(data.message || 'Unable to send verification mail');
      }
    } catch {
      setError('Connection error. Is the server running?');
      message.error('Connection error. Is the server running?');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-[linear-gradient(180deg,#0b4d7b_0%,#067fc2_100%)] flex items-center justify-center px-4 py-10 font-sans">
      <div className="absolute inset-0 pointer-events-none opacity-70">
        <div className="absolute left-[-8%] top-[10%] h-64 w-64 rounded-full bg-white/10 blur-[90px]" />
        <div className="absolute right-[-10%] bottom-[8%] h-72 w-72 rounded-full bg-cyan-300/20 blur-[110px]" />
      </div>

      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="relative z-10 w-full max-w-[520px]">
        <div className="flex flex-col items-center gap-8">
          <div className="flex items-end justify-center gap-1">
            <div className="relative flex h-20 w-20 items-center justify-center rounded-[24px] bg-white/10 text-[44px] font-semibold text-white shadow-[0_16px_40px_rgba(0,0,0,0.18)] backdrop-blur-sm">
              <span className="absolute right-5 top-5 h-5 w-5 rounded-full bg-white" />
              <span className="translate-y-[2px] tracking-[-0.12em]">V</span>
            </div>
            <div className="text-[72px] font-semibold leading-none tracking-[-0.12em] text-cyan-200">MS</div>
          </div>

          <div className="wm-card w-full overflow-hidden rounded-[24px] border border-white/70 bg-white p-8 shadow-[0_22px_80px_rgba(2,24,49,0.24)] md:p-12">
            <div className="mb-8 text-center">
              <h1 className="text-[34px] font-semibold tracking-[-0.03em] text-slate-700">Forgot Password</h1>
              <p className="mt-2 text-[18px] text-slate-700">Welcome to VMS Portal !</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
              {messageText && (
                <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4 text-sm font-medium text-emerald-700">
                  {messageText}
                </div>
              )}

              {error && (
                <div className="rounded-2xl border border-rose-200 bg-rose-50 p-4 text-sm font-medium text-rose-700">
                  {error}
                </div>
              )}

              <div className="space-y-2">
                <label className="block text-[18px] font-medium text-slate-700">
                  <span className="text-rose-500">*</span> Email
                </label>
                <Input
                  size="large"
                  prefix={<FiMail className="mr-2 text-sky-600" />}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="h-14 rounded-[10px] border-slate-200 text-[16px] shadow-[0_0_0_1px_rgba(2,24,49,0.02)]"
                  required
                />
                <p className="pt-1 text-[16px] text-slate-600">Enter your email, we&apos;ll send you the link!</p>
              </div>

              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                className="w-full h-14 rounded-[10px] border-0 bg-[linear-gradient(180deg,#0b5f95_0%,#0a4c7a_100%)] text-[16px] font-semibold shadow-none hover:!bg-[linear-gradient(180deg,#0a5384_0%,#083c61_100%)]"
              >
                SEND VERIFICATION MAIL
              </Button>

              <div className="pt-4 text-center text-[17px] text-slate-600">
                <Link to="/login" className="font-medium text-sky-500 underline decoration-sky-400/40 underline-offset-4">
                  Back to Sign In
                </Link>
              </div>
            </form>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default ForgotPassword;